module.exports = __webpack_public_path__ + "resources/img/img_rancher5_m.8079334916cc6ef39d6c38033188968e.png";